var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificationCenter"},_vm._l((_vm.$store.state.notifications.list),function(notif,i){return _c('notice',{key:i,attrs:{"type":notif.type}},[_c('p',[_vm._v(_vm._s(notif.text))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }